import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { Subject } from 'rxjs';

import { DialogResult } from '../../../notification/dialogs/dialog-result.enum';
import { DialogType } from '../../../notification/dialogs/dialog-type.enum';

@Component({
  selector: 'app-message-dialog_pedido',
  templateUrl: './message-dialog_pedido.component.html',
  styleUrls: ['./message-dialog_pedido.component.scss'],
})
export class MessageDialogPedidoComponent implements OnInit {
  dialogResult$ = new Subject<DialogResult>();
  message = '';
  options?: { htmlMessage: boolean };
  title!: string;
  type!: DialogType;
  types = DialogType;

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    private dialogData: any,
    public dialogRef: MatDialogRef<MessageDialogPedidoComponent>,
  ) {}

  ngOnInit(): void {
    this.title = this.dialogData.title || '';
    this.message = this.dialogData.message || 'Mensaje de ejemplo';
    this.type = this.dialogData.type;
    this.options = this.dialogData.options;
  }

  onClick(value: 'accept' | 'cancel'): void {
    this.dialogResult$.next(value === 'accept' ? DialogResult.Ok : DialogResult.Cancel);
    this.dialogResult$.complete();
    this.dialogRef.close();
  }
}
